import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SearchPageShell } from "@/pages/search/SearchDocLayout";
import { fetchServices } from "@/lib/searchContent";
import { openContactForm } from "@/lib/contactForm";

export default function ServicesIndexPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchServices()
      .then((data) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, []);

  const featured = items[0] || null;
  const rest = featured ? items.slice(1) : items;

  return (
    <SearchPageShell testId="services-index" wide flush>
      <section className="ds-guide-hero" aria-labelledby="services-hero-title">
        <p className="ds-search-kicker">SERVICES</p>
        <h1 id="services-hero-title" className="ds-search-h1">
          디자인에서 개발, 관리자,
          <br />
          AI와 자동화까지
        </h1>
        <p className="ds-search-summary">
          DSITESOLUTION은 홈페이지만 납품하지 않습니다. 브랜드 웹, 맞춤 프론트/백엔드, 관리자/CMS, AI, 업무 자동화, SaaS,
          SEO · AEO · GEO를 한 흐름으로 구축합니다.
        </p>
        <div className="ds-guide-hero__actions">
          <Link className="ds-guide-ghost" to="/capabilities">역량 한눈에 보기</Link>
          <Link className="ds-guide-ghost" to="/guides">가이드</Link>
        </div>
      </section>
      {featured ? (
        <article className="ds-guide-featured">
          <Link className="ds-guide-featured__link" to={featured.path} data-testid={`service-card-${featured.slug}`}>
            <p className="ds-search-kicker">{featured.eyebrow}</p>
            <p className="ds-guide-featured__label">Core Service</p>
            <h2>{featured.title}</h2>
            <p>{featured.summary}</p>
            <span className="ds-guide-more">서비스 보기 →</span>
          </Link>
        </article>
      ) : null}
      <div className="ds-search-grid ds-guide-grid" data-testid="services-grid">
        {rest.map((item) => (
          <Link key={item.id} className="ds-search-card" to={item.path} data-testid={`service-card-${item.slug}`}>
            <p className="ds-search-kicker">{item.eyebrow}</p>
            <h2>{item.title}</h2>
            <p>{item.summary}</p>
            <span className="ds-guide-more">서비스 보기 →</span>
          </Link>
        ))}
      </div>
      <section className="ds-guide-cta-band">
        <h2>어떤 범위가 맞는지 정리해 드립니다.</h2>
        <p>홈페이지만 필요한 경우와 시스템까지 필요한 경우를 나눠 안내합니다.</p>
        <a className="ds-search-cta" href="/#contact" onClick={(e) => { e.preventDefault(); openContactForm(); }}>
          상담 신청
        </a>
      </section>
    </SearchPageShell>
  );
}
